import { ErrorMessage as RHFErrorMessage } from '@hookform/error-message'
import { type FC } from 'react'
import { useFormContext } from 'react-hook-form'

type Props = {
  dataQaId?: string
  name: string
}

export const RxLpChErrorMessage: FC<Props> = ({ dataQaId, name }) => {
  const {
    formState: { errors },
  } = useFormContext()

  return (
    <RHFErrorMessage
      errors={errors}
      name={name}
      render={({ message }) =>
        message ? (
          <div
            className="self-stretch text-dark-error-strong"
            data-qa-id={dataQaId}
          >
            {message}
          </div>
        ) : null
      }
    />
  )
}
